import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT } from "@/data/catalog";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/waffen", label: "Waffen" },
  { to: "/munition", label: "Munition" },
  { to: "/zubehoer", label: "Zubehör" },
  { to: "/fachhandel", label: "Fachhandel" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-stretch">
        <Link to="/" className="flex items-center border-r border-border px-5 py-3" data-testid="nav-logo">
          <Logo />
        </Link>

        <nav className="hidden flex-1 items-stretch lg:flex" aria-label="Hauptnavigation">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `mono-label flex items-center border-r border-border px-5 transition-colors ${
                  isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground hover:bg-card"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <a
          href={`tel:${CONTACT.phoneHref}`}
          data-testid="nav-phone"
          className="mono-label ml-auto hidden items-center gap-2 px-5 text-foreground hover:text-primary lg:flex"
        >
          <Phone size={14} /> {CONTACT.phone}
        </a>

        <button
          className="ml-auto px-5 lg:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menü"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-border lg:hidden" aria-label="Mobile Navigation">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`mnav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `mono-label block border-b border-border px-5 py-4 ${
                  isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <a href={`tel:${CONTACT.phoneHref}`} className="mono-label block px-5 py-4 text-primary" data-testid="mnav-phone">
            {CONTACT.phone}
          </a>
        </nav>
      )}
    </header>
  );
}
